import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import getAccount from "Redux/Actions/GetAccountAction";

import AppConstants from "Constants/AppConstants";

import { getProductFromVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import {
  getFinancialAnalysisFinancialList,
  deleteLoanFinancial,
} from "Components/LoanDetails/Actions/LoanDetailsAction";
import Expense from "./Expense";
import {
  addLoanExpense,
  updateLoanExpense,
  getLoanExpense,
} from "./Actions/ExpenseActions";
import {
  getFinancialList,
  getLoanProduct,
} from "../LoanDetails/Actions/LoanDetailsAction";

class ExpenseContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      choice: false,
      financialType: "Expense",
      oldExpenseList: null,
      expenseList: [],
      success: true,
    };
  }

  componentDidMount() {
    console.log("componentDidMount");
    const {
      products,
      getActiveProduct,
      handleBack,
      continuehandler,
      actionBack,
    } = this.props;
    const activeProduct = getActiveProduct(products);
    console.log(activeProduct);
    if (
      (activeProduct.category === AppConstants.LOAN_CATEGORY.PERSONAL ||
        activeProduct.category === AppConstants.LOAN_CATEGORY.LOC) &&
      activeProduct.loanDetails.loanAmount <= activeProduct.cutoff
    ) {
      if (actionBack) {
        handleBack(AppConstants.APPLICATIONSTEP.EXPENSE);
      } else {
        continuehandler(null, AppConstants.APPLICATIONSTEP.EXPENSE);
      }
    } else {
      this.initializeLoanDetail();
    }
  }

  handleChange = (choice) => {
    console.log(choice);
    const { expenseList } = this.state;
    this.setState({ choice: choice });
    if (choice) {
      expenseList.push({
        expenseType: "",
        description: "",
        monthlyAmount: "",
        adjustment: "",
      });
      this.setState({
        expenseList,
      });
    } else {
      this.setState({
        expenseList: [],
      });
    }
  };

  handleContinue = (expenseList) => {
    console.log("handleContinue");
    const { financialType } = this.state;
    const {
      continuehandler,
      products,
      getActiveProduct,
      doGetFinancialAnalysisFinancialList,
    } = this.props;
    const activeProduct = getActiveProduct(products);

    doGetFinancialAnalysisFinancialList(
      {
        applicantId: activeProduct.applicantId,
        finAnalysisId: activeProduct.finAnalysisId,
      },
      (res) => {
        const currentExpenseList = [];
        res.forEach((financial, idx) => {
          if (financial.type === financialType && idx !== 0) {
            currentExpenseList.push({
              expenseType: financial.subType,
              description: financial.description,
              monthlyAmount: financial.monthly,
              financialId: financial.financialId,
            });
          }
        });
        this.processExpense(currentExpenseList, expenseList, activeProduct);
        continuehandler("", AppConstants.APPLICATIONSTEP.EXPENSE);
      }
    );
  };

  processExpense(currentExpenseList, newExpenseList, activeProduct) {
    console.log("processExpense", currentExpenseList, newExpenseList);

    newExpenseList.forEach((expense, idx) => {
      if (expense.financialId) {
        const currentExpense = currentExpenseList.find(
          (item) => item.financialId === expense.financialId
        );
        this.updateExpense(activeProduct, currentExpense, expense);
      } else {
        this.addExpense(activeProduct, expense);
      }
    });

    currentExpenseList.forEach((expense, idx) => {
      const curr = newExpenseList.find(
        (item) => item.financialId === expense.financialId
      );
      if (!curr) {
        this.deleteExpense(activeProduct, expense);
      }
    });
  }

  addExpense(activeProduct, expense) {
    console.log("addExpense", expense);
    const { doAddLoanExpense } = this.props;
    doAddLoanExpense(
      activeProduct.applicantId,
      activeProduct.finAnalysisId,
      {
        SubType: expense.expenseType,
        Description: expense.description,
        MonthlyAmount: this.removeInvalidChars(expense.monthlyAmount),
      },
      (res) => {
        console.log(res);
      }
    );
  }

  removeInvalidChars(value) {
    if (value) {
      return value.replaceAll("$", "").replaceAll(",", "");
    } else {
      return value;
    }
  }

  updateExpense(activeProduct, oldExpense, newExpense) {
    console.log("updateExpense", oldExpense, newExpense);
    const { doUpdateLoanExpense } = this.props;
    if (
      oldExpense.expenseType !== newExpense.expenseType ||
      oldExpense.description !== newExpense.description ||
      oldExpense.monthlyAmount !== newExpense.monthlyAmount
    ) {
      doUpdateLoanExpense(
        activeProduct.applicantId,
        activeProduct.finAnalysisId,
        newExpense.financialId,
        {
          SubType: newExpense.expenseType,
          Description: newExpense.description,
          MonthlyAmount: this.removeInvalidChars(newExpense.monthlyAmount),
        },
        (res) => {
          console.log(res);
        }
      );
    }
  }

  parseAmount(str) {
    if (isNaN(str)) {
      const matches = str.match(/(\d+)/);
      if (matches) {
        return matches[0];
      } else {
        return 0;
      }
    } else {
      return str;
    }
  }

  deleteExpense = (activeProduct, expense) => {
    console.log("deleteExpense", expense);
    const { doDeleteLoanFinancial } = this.props;

    if (expense) {
      doDeleteLoanFinancial(
        activeProduct.applicantId,
        activeProduct.finAnalysisId,
        expense.financialId,
        (res) => {}
      );
    }
  };

  initializeLoanDetail() {
    const {
      products,
      getActiveProduct,
      doGetFinancialAnalysisFinancialList,
    } = this.props;
    const { financialType } = this.state;

    const activeProduct = getActiveProduct(products);
    console.log(activeProduct);
    doGetFinancialAnalysisFinancialList(
      {
        applicantId: activeProduct.applicantId,
        finAnalysisId: activeProduct.finAnalysisId,
      },
      (res) => {
        const expenseList = [];
        res.forEach((financial, idx) => {
          if (financial.type === financialType && idx !== 0) {
            expenseList.push({
              expenseType: financial.subType,
              description: financial.description,
              monthlyAmount: financial.monthly,
              adjustment: financial.adjustment,
              financialId: financial.financialId,
              applicantId: activeProduct.applicantId,
              finAnalysisId: activeProduct.finAnalysisId,
            });
          }
        });
        console.log(expenseList);
        this.setState({
          expenseList: expenseList,
          choice: expenseList && expenseList.length > 0,
        });
      }
    );
  }

  render() {
    const { choice, expenseList } = this.state;
    const {
      getDataFromServer,
      handleBack,
      steps,
      activeStepID,
      expenseTypes,
    } = this.props;

    return (
      <>
        <Expense
          handleContinue={this.handleContinue}
          handleChange={this.handleChange}
          deleteExpense={this.deleteExpense}
          getDataFromServer={getDataFromServer}
          choice={choice}
          handleBack={handleBack}
          steps={steps}
          activeStepID={activeStepID}
          expenseList={expenseList}
          expenseTypes={expenseTypes}
        />
      </>
    );
  }
}

ExpenseContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

ExpenseContainer.defaultProps = {
  steps: [],
  activeStepID: -1,
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  loanProductForm: state.LoanDetailsReducer.loanProductForm,
  finAnalysisId: state.LoanDetailsReducer.finAnalysisId,
  financialAnalysisFinancialList:
    state.LoanDetailsReducer.financialAnalysisFinancialList.data,
  expenseTypes: state.LoanDetailsReducer.expenseTypes,
  actionBack: state.ApplicationReducer.actionBack,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doAddLoanExpense: (applicantId, finAnalysisId, payLoad, callback) =>
      dispatch(addLoanExpense(applicantId, finAnalysisId, payLoad, callback)),
    doUpdateLoanExpense: (
      applicantId,
      finAnalysisId,
      financialId,
      payLoad,
      callback
    ) =>
      dispatch(
        updateLoanExpense(
          applicantId,
          finAnalysisId,
          financialId,
          payLoad,
          callback
        )
      ),
    doGetLoanProduct: (callback) => dispatch(getLoanProduct(callback)),
    doGetLoanExpense: (
      applicantId,
      finAnalysisId,
      financialId,
      payLoad,
      callback
    ) =>
      dispatch(
        getLoanExpense(
          applicantId,
          finAnalysisId,
          financialId,
          payLoad,
          callback
        )
      ),
    doGetFinancialAnalysisFinancialList: (request, callback) =>
      dispatch(getFinancialAnalysisFinancialList(request, callback)),
    doGetFinancialList: (reqData, callback) =>
      dispatch(getFinancialList(reqData, callback)),
    doDeleteLoanFinancial: (
      applicantId,
      finAnalysisId,
      financialId,
      payLoad,
      callback
    ) =>
      dispatch(
        deleteLoanFinancial(
          applicantId,
          finAnalysisId,
          financialId,
          payLoad,
          callback
        )
      ),
  };
};

const ExpenseWrapper = withApplicantHOC(ExpenseContainer);

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseWrapper);
